module.exports = __webpack_public_path__ + "assets/124a6fbdbcadbf8da92aa0c45a348ac1.png";